export function waitForControllersToInitialize() {
  // Use this to wait for all other controllers to be initialized.
  // Useful if you need one controller to communicate with another.
  // See: https://github.com/hotwired/stimulus/issues/201
  return Promise.resolve();
}
